<template>
    <div class="showroomblock-container">
        <div class="main-box page-content-box">
            <BlockTitle
                title="王选纪念陈列室"
                channelAlias="chenlieshi"></BlockTitle>
            <div class="brief">
                <p>王选教授一生的伟大成就和高风亮节，是我们宝贵的精神财富。为了使更多的人特别是年轻一代，能够亲身感受王选教授的高尚品格、动人事迹和思想精神，从中受到教育、激励和启迪，把“王选精神”发扬光大。</p>
                <p>2007年2月13日王选教授逝世一周年之际，王选纪念陈列室建成开放。</p>
            </div>
            <div class="showroom-wrap" ref="showroomWrap" :style="{height: wrapHeight}">
                <div class="cover-box"  :style="{height: coverHeight}">
                    <el-image
                        class="cover-img"
                        style="width: 100%;height: 100%;"
                        :src="require('@/assets/img/showroom01.jpg')"
                        fit="cover"
                    ></el-image>
                </div>
                <div class="order-box" ref="orderBox">
                    <div class="order-box-layout">
                        <div class="order-buttons">
                            <div class="btn-flat" @click="handleGochannel('chenlieshijianjie')" ref="briefBtn">
                                <div class="img-btn-wrap">
                                    <div class="btn-name">陈列室简介</div>                                    
                                    <div class="btn-image"></div>
                                </div>
                            </div>
                            <div class="btn-flat" @click="handleGochannel('zhanguanchenlie')">
                                <div class="img-btn-wrap">
                                    <div class="btn-name">展馆陈列</div>
                                    <div class="btn-image"></div>
                                </div>
                            </div>
                            <div class="btn-flat" @click="handleGochannel('chenlieshidongtai')">
                                <div class="img-btn-wrap">
                                    <div class="btn-name">陈列室动态</div>
                                    <div class="btn-image"></div>
                                </div>
                            </div>
                        </div>
                        <div class="order-description">
                            <div class="description-wrap">
                                <div class="title">预约参观</div>
                                <div class="content">
                                    <p>开放时间：工作日 09:30-17:00</p>
                                    <p>地　　点：北京市海淀区成府路298号北大科技大厦</p>
                                    <p>接待方式：网上预约，因陈列室面积所限，每次接待人数为30人左右。</p>                                    
                                </div>
                                <div class="op">
                                    <div class="btn-flat order-btn"  
                                        :style="{width: orderBtnWidth}"
                                        @click="handleGochannel('yuyuecanguan')">立即预约</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>            
        </div>
    </div>
</template>
<script>
    import BlockTitle from "@/components/blocks/blocktitle";
    export default{
        components: {BlockTitle},
        props:{},
        data(){
            return {
                wrapHeight: '100%',
                coverHeight: '100%',
                orderBtnWidth: '136px',
            };
        },
        methods:{
            handleGochannel(alias){
                this.$router.push(
                    {
                        path: '/chenlieshi',
                        query:{
                            tab: alias,
                        }
                    }
                );
            },

            onResize(){
                //let screenW = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                let screenW = this.$refs.showroomWrap.clientWidth;
                //console.log('screenW=',screenW);
                let height = 180;
                if(screenW > 600){
                    height = screenW * (3/10);
                    if(height <= 360){
                        height = 360;
                    }
                    this.wrapHeight = height + 'px';
                    this.coverHeight = '100%';
                    //console.log(this.$refs.briefBtn.clientWidth);
                    this.orderBtnWidth = this.$refs.briefBtn.clientWidth + 'px';
                }else{
                    // 窄屏固定高度
                    this.wrapHeight = height + this.$refs.orderBox.clientHeight + 'px';
                    this.coverHeight = height + 'px';
                    this.orderBtnWidth = '100%';
                }
                                     
            }
        },
        created(){
            window.addEventListener('resize', this.onResize);
        },
        destroyed(){
            window.removeEventListener('resize', this.onResize);
        },
        mounted(){
            this.$nextTick(()=>{
                this.onResize();
            });
        },
    };
</script>
<style scoped>
    .showroomblock-container{
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        align-items: center;
        padding: 60px 0px;
        background: #FFFFFF;
        background-image: url('../../../assets/img/home-bg-room.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        /*filter: opacity(0.4000000059604645);*/
    }
    .main-box{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        align-items: center;        
    }
    .showroom-wrap{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        width: 100%; 
        padding: 0px;       
        margin-top: 40px; 
    }

    .brief{
        width: 80%;
        margin-top: 40px;
    }
    /deep/.brief p{
        font-size: 16px;
        font-weight: normal;
        line-height: 32px;
        letter-spacing: 0em;
        color: #000000;
        text-indent: 2em;
        margin-block-start: 0px !important;
        margin-block-end: 0px !important;
    }

    .el-row{
        width: 100%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        box-sizing: border-box;
    }

    .cover-box{
        flex: 0 0 50%;
        height: 100%;
        overflow: hidden;        
    } 

    .cover-img{            
        transition:all 0.35s ease-in-out;
      overflow: hidden;
    }
    .cover-img:hover{
      transform: scale(1.1);
      overflow: hidden;
    }    

    .order-box{
        flex: 0 0 50%;
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        padding: 0px;
        align-self: stretch;
        background: #FFFFFF;        
        box-sizing: border-box;
        align-items: flex-start;        
        padding: 30px 30px 10px 30px;
    }
    .order-box-layout{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
    }

    .order-buttons{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: row;        
        align-self: stretch;
        justify-content: space-between;
        width: 100%;
    }
    .order-buttons>div{
        margin-left: 20px;
    }
    .order-buttons>div:first-child{
        margin-left: 0px;
    }

    .order-description{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        align-self: stretch;
        margin-top: 30px;
    }

    .description-wrap{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        padding: 0px 0px;        
    }
    .description-wrap>div{
        margin-top: 20px;
    }
    .description-wrap>div:first-child{
        margin-top: 0px;
    }

    .description-wrap .title{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        flex-direction: column;
        padding: 0px;
        align-self: stretch;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        letter-spacing: 0em;
        color: #000000;
    }

    .description-wrap .content{
        font-size: 14px;
        font-weight: normal;
        line-height: 28px;
        letter-spacing: 0em;
        color: #3B3F47;

    }
    /deep/ .description-wrap .content p{
        margin-block-start: 0px !important;
        margin-block-end: 0px !important;
    }

    .description-wrap .op{

    }
    .btn-flat{
        padding: 6px 18px;        
        box-sizing: border-box;
        border: 2px solid #014289;
        display: inline-block;
        cursor: pointer;
        font-size: 14px;
        font-weight: bold;
        line-height: 16px;
        text-align: center;
        letter-spacing: 0em;
        color: #014289;
        flex-grow: 1;
    }

    .btn-flat:hover{
        background: #014289;
        color: #fff;
    }

    .img-btn-wrap{
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        justify-content: space-between; 
    }

    .btn-name{
        flex-grow: 1;       
        text-align: left; 
    }

    .btn-image{
        background: url('~@/assets/icons/svg/circle-right-arrow.svg') no-repeat;
        background-size: cover;       
        flex: 0 0 20px;
        height: 20px;
        display: inline-block;
        margin-left: 10px;
        box-sizing: border-box;
    }


    .img-btn-wrap:hover>:last-child{
        background: url('~@/assets/icons/svg/circle-right-arrow-white.svg') no-repeat;
        background-size: cover;    
    }
    .order-btn{
        background-color: #014289;
        color: #fff;
    }
    .order-btn:hover{
        background-color: #00346c;
    }

    @media screen and (max-width: 1000px){
        .showroomblock-container{
            padding: 24px 0px;
        }
        
        .showroom-wrap{   
            margin-top: 20px; 
        }
        .brief{            
            margin-top: 20px;
        }
        
        .order-buttons>div{
            margin-left: 10px;
        }


        .btn-flat{
            padding: 6px 10px;
        }
    }

    @media screen and (max-width: 900px){
        .order-buttons>div{
            margin-left: 10px;
        }
        .btn-flat{
            padding: 6px 10px;
        }
        .btn-name{
            flex-grow: 1;       
            text-align: center; 
        }
        .btn-image{
            display: none;
        }
    }

    @media screen and (max-width: 650px) {
        .showroom-wrap{
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            flex-direction: column;
            width: 100%;
            padding: 0px; 
        }
        .brief{
            width: 100%;  
        }
        .brief p{
            font-size: 14px !important;
            line-height: 28px;
            padding: 0 10px;
        }
        .cover-box{
            flex: unset;
            width: 100%;
        }
        .order-box{
            flex: unset;
            width: 100%;            
            align-items: flex-start;        
            padding: 10px 20px 30px 20px;
        }
        .order-buttons>div{
            margin-left: 10px;
        }
        .btn-flat{
            padding: 6px 10px;
        }
        .btn-name{
            flex-grow: 1;       
            text-align: center; 
        }
        .btn-image{
            display: inline-block;
        }

    }
    @media screen and (max-width: 460px){
        .order-box{
            padding: 10px 16px;
        }
        .btn-image{
            display: none;
        }
    }

    
</style>



// WEBPACK FOOTER //
// src/components/blocks/showroomblock/index.vue